import React from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import axios from "axios";
import * as Colors from "material-ui/styles/colors";

const muiTheme = getMuiTheme({
  palette: {
    textColor: Colors.darkBlack,
    primary1Color: Colors.lightGreen600,
    primary2Color: Colors.indigo700,
    accent1Color: Colors.lightGreen600,
    pickerHeaderColor: Colors.lightGreen600,
    alternateTextColor: Colors.white
  },
  appBar: {
    height: 45
  }
});

export default class IzmeniRadnika extends React.Component {
  constructor(props) {
    super(props);
    this.state={obrociData:[]}
  }



  getNadjiRadnika = (idfirme,filter) => {
    var query = "/findRadnik/" + idfirme + "/" + filter;
    axios.get(query).then(res => {
      const data = res.data.data;
      this.setState({ obrociData: data});
      console.log(data);
    });
  };

  componentDidMount() {
 this.getNadjiRadnika(this.props.match.params.idfirme
              ,this.props.match.params.searchstring);
  }

  render() {
    
    return (
      <div
        style={{
          marginTop: 0,
          marginBottom: 0,
          padding: 0,
          fontFamily: "Raleway",
          textAlign: "left",
          background: "#fff",
          color: "white",
          fontSize: "14px",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <MuiThemeProvider muiTheme={muiTheme}>
          
            <div>
             
            </div>
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Moduli/IzmeniRadnika.js